<template>
  <div
    style="height:98.4vh;overflow: hidden;margin:.4vh;position: relative"
    :style="{
      width: width,
      'min-width': minWidth || fixWidth ? width : '',
      'flex-grow': grow ? 1 : 0,
      'max-width': maxWidth || fixWidth ? width : ''
    }"
  >
    <v-card
      v-if="card"
      style="height:100%;width:100%;overflow: hidden;display:flex;flex-direction: column"
      :color="color"
      :elevation="2"
      ><div
        v-if="gradientTop"
        style="position: absolute;top:0;left:0;width:100%;height:50px;pointer-events: none"
        :class="gradientSofter ? 'gradient-softer' : 'gradient'"
      ></div>
      <div
        v-if="$slots.header"
        class="flex-block-center header"
        style="min-height:48px;border-bottom:1px solid rgba(0,0,0,.2)"
      >
        <slot name="header"></slot>
      </div>
      <div
        class="flex-grow-1"
        style="width:100%;overflow: auto;display:flex;flex-direction: column"
      >
        <slot />
      </div>

      <div
        v-if="$slots.footer"
        class="flex-block-center"
        style="height:59px;background-color: rgba(255,255,255,.8);border-top:1px solid rgba(0,0,0,.2)"
      >
        <slot name="footer"></slot>
      </div>
    </v-card>
    <div v-if="!card" style="height:100%;width:100%;overflow: hidden">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageColumn",
  props: {
    width: {
      type: String
    },
    grow: {
      type: Boolean
    },
    card: {
      type: Boolean
    },
    color: {
      type: String,
      default: "light1"
    },
    gradientTop: {
      type: Boolean
    },
    gradientSofter: {
      type: Boolean
    },
    maxWidth: {
      type: String
    },
    minWidth: {
      type: String
    },
    fixWidth: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.gradient {
  background: rgb(239, 239, 238);
  background: linear-gradient(
    180deg,
    rgba(239, 239, 238, 1) 0%,
    rgba(239, 239, 238, 1) 12%,
    rgba(239, 239, 238, 0) 90%
  );
}
.gradient-softer {
  background: rgb(239, 239, 238);
  background: linear-gradient(
    180deg,
    rgba(239, 239, 238, 0.5) 0%,
    rgba(239, 239, 238, 0.4) 12%,
    rgba(239, 239, 238, 0) 90%
  );
}
.header {
  background-color: $light5;
}
</style>
